import React from 'react';
import { Skeleton } from '../skeleton/index.js';
import styled from 'styled-components';
import { SYS_SIZE_FIXED_1000, SYS_SIZE_FIXED_800, SYS_SIZE_FIXED_900, SYS_SIZE_FIXED_600, SYS_BREAKPOINT_LG, SYS_SIZE_FIXED_1200, SYS_BREAKPOINT_XL, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_700, SYS_BREAKPOINT_2_XL, SYS_SIZE_FIXED_1600 } from '@oneaudi/unified-web-alpha-common';
const StyledHeadlineSkeleton = styled(Skeleton) `
  width: ${(props) => props.width ?? '100%'};

  height: ${(props) => props.order === '1'
    ? SYS_SIZE_FIXED_1000
    : props.order === '2'
        ? SYS_SIZE_FIXED_900
        : props.order === '3'
            ? SYS_SIZE_FIXED_800
            : SYS_SIZE_FIXED_600};

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    height: ${(props) => props.order === '1'
    ? SYS_SIZE_FIXED_1200
    : props.order === '2'
        ? SYS_SIZE_FIXED_1000
        : props.order === '3'
            ? SYS_SIZE_FIXED_800
            : SYS_SIZE_FIXED_600};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    height: ${(props) => props.order === '1'
    ? SYS_SIZE_FIXED_1400
    : props.order === '2'
        ? SYS_SIZE_FIXED_1200
        : props.order === '3'
            ? SYS_SIZE_FIXED_900
            : SYS_SIZE_FIXED_700};
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    height: ${(props) => props.order === '1'
    ? SYS_SIZE_FIXED_1600
    : props.order === '2'
        ? SYS_SIZE_FIXED_1400
        : props.order === '3'
            ? SYS_SIZE_FIXED_900
            : SYS_SIZE_FIXED_800};
  }
`;
export const HeadlineSkeleton = ({ order, margin, width, 'data-testid': dataTestId, className }) => (React.createElement(StyledHeadlineSkeleton, { "data-testid": dataTestId, variant: "oval", order: order, margin: margin, width: width, className: className }));
//# sourceMappingURL=index.skeleton.js.map